import { Box } from "@mui/material";
import React from "react";
import CoreTypographyBody1 from "../dataDisplay/CoreTypographyBody1";
import { theme } from "../../config/theme";

export default function FullPageLoader() {
  return (
    <Box
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
        backgroundColor: "black",
        opacity: 0.8,
      }}
    >
      <CoreTypographyBody1
        style={{ color: theme?.palette?.primary?.contrastText }}
      >
        Loading...
      </CoreTypographyBody1>
    </Box>
  );
}
